import React from "react";
import { useTranslation } from "react-i18next";
import OptimizedImage from "../components/image-optimization/OptimizedImage";
import Tooltip from "../components/Tooltip";

const ExtraServiceItem: React.FC<{
  name: string;
  price: string;
  unit: string;
  items: string[];
  image: string;
  showTooltipOnLastItem?: boolean;
  tooltipText?: string;
  lastItemText?: string;
}> = ({ name, price, unit, items, image, showTooltipOnLastItem = false, tooltipText, lastItemText }) => {
  return (
    <div className="pricing-card" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <OptimizedImage
        src={image}
        alt={name}
        style={{ height: "180px", width: "100%", objectFit: "cover" }}
      />
      <div className="desc" style={{ display: "flex", flexDirection: "column", flex: "1" }}>
        <div className="name">{name}</div>
        <div className="amount">
          {price} €<span className="unit">/{unit}</span>
        </div>
        <ul className="list-unstyled list" style={{ flex: "1", marginLeft: 0, marginRight: 0 }}>
          {items.map((item, index) => {
            const isLastItem = index === items.length - 1;
            const shouldShowTooltip = isLastItem && showTooltipOnLastItem;

            return (
              <li key={index}>
                <i className="ti-check"></i>{" "}
                {shouldShowTooltip ? (
                  <Tooltip text={tooltipText || item}>
                    {lastItemText || item}
                  </Tooltip>
                ) : (
                  item
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

const ExtraSection: React.FC = () => {
  const { t: tHome } = useTranslation("home");
  const { t: tContact } = useTranslation("contact");
  const { t: tCommon } = useTranslation("common");

  return (
    <section className="pricing section-padding bg-blck">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="section-subtitle">
              <span>{tCommon("fullName")}</span>
            </div>
            <div className="section-title">
              <span>{tHome("extra.title")}</span>
            </div>
            <p className="color-2">{tHome("extra.description")}</p>
            <p className="color-2">{tHome("extra.additionalInfo")}</p>
            <div className="reservations mb-30">
              <div className="icon">
                <span className="flaticon-call"></span>
              </div>
              <div className="text">
                <p className="color-2">{tHome("extra.contactText")}</p>
                <a href={`tel:${tContact("phone.number")}`}>
                  {tContact("phone.label")}
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="owl-carousel owl-theme">
              <ExtraServiceItem
                name={tHome("extra.items.parking.name")}
                price={tHome("extra.items.parking.price")}
                unit={tHome("extra.items.parking.unit")}
                items={[
                  tHome("extra.items.parking.item1"),
                  tHome("extra.items.parking.item2"),
                  tHome("extra.items.parking.item3"),
                ]}
                image="images/services/park.jpg"
                showTooltipOnLastItem={true}
                tooltipText={tHome("extra.items.parking.item3")}
                lastItemText="Voir les tarifs"
              />
              <ExtraServiceItem
                name={tHome("extra.items.breakfast.name")}
                price={tHome("extra.items.breakfast.price")}
                unit={tHome("extra.items.breakfast.unit")}
                items={[
                  tHome("extra.items.breakfast.item1"),
                  tHome("extra.items.breakfast.item2"),
                  tHome("extra.items.breakfast.item3"),
                ]}
                image="images/services/breakfast1.jpg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExtraSection;
